import { memo, useCallback, useRef, useState, useEffect } from 'react';
import { CFormInput, CImage, CFormFeedback } from '@coreui/react-pro';
import classNames from 'classnames';

import { cloneDeep, useOutsideHandling } from '../../../../utils';
import { DEFAULT_FN } from '../../../../constants';
import images from '../../../../assets/images';

const AssignSeatUserSearch = ({ initialValues, value, error, disabled, setFieldValue }) => {
     const wrapperRef = useRef(null);

     const [isOpenSelect, setIsOpenSelect] = useState(false);
     const [valueQuery, setValueQuery] = useState('');
     const [checkEmail, setCheckEmail] = useState({});

     const valueDefault = { value: '', label: 'Select email', noEmail: true };
     const [options, setOptions] = useState([valueDefault, ...initialValues]);

     const clickOutside = useCallback(() => {
          setIsOpenSelect(false);
     }, []);
     useOutsideHandling(wrapperRef, clickOutside);

     const onSelectChange = (e) => {
          const toggleOpenTimer = setTimeout(() => {
               setIsOpenSelect((prevIsOpenSelect) => !prevIsOpenSelect);
               clearTimeout(toggleOpenTimer);
          }, 0);

          setCheckEmail({ userId: e });

          if (!e) {
               setOptions([valueDefault, ...initialValues]);
          }
          if (checkEmail.userId !== 'Select email' || checkEmail.userId !== '') {
               setFieldValue('userId', e);
          }
     };

     useEffect(() => {
          setValueQuery('');
          setValueQuery(value);
     }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleFilterSearchEmail = (e) => {
          const query = e.target.value.trim();
          setValueQuery(query);

          if (!query) {
               setOptions([valueDefault, ...initialValues]);
               return;
          }

          const optionsFilterSearch = initialValues?.filter((option) => option.label.includes(query));

          if (optionsFilterSearch.length > 0) {
               setOptions([valueDefault, ...optionsFilterSearch]);
          } else {
               setOptions(optionsFilterSearch);
          }
     };

     const handleClickExpandOption = () => {
          setIsOpenSelect(true);
          setOptions([valueDefault, ...initialValues]);
          setValueQuery('');

          if (!value) return;

          const newOptions = initialValues.filter((option) => option.label !== value) || cloneDeep(options);
          setOptions([valueDefault, ...newOptions]);
          setValueQuery(value);
     };

     return (
          <div ref={wrapperRef} className="custom-seats-search">
               {isOpenSelect ? (
                    <div className="box-search">
                         <div className="icon-dropdown" onClick={() => setIsOpenSelect(false)}>
                              <CImage src={images.arrowDownDarkCeruleanIcon} className="icon-item" alt="Arrow Down Blue Icon" width={10} height={6} />
                         </div>
                         <CFormInput
                              id="userId"
                              className="input-search"
                              placeholder="Type to search"
                              value={valueQuery}
                              onChange={handleFilterSearchEmail}
                         />
                         <ul>
                              {options.length > 0 ? (
                                   options.map((option, index) => (
                                        <li
                                             key={index}
                                             className={`${option.noEmail ? 'no-email' : ''}`}
                                             onClick={() => onSelectChange(option.value)}
                                        >
                                             {option.label}
                                        </li>
                                   ))
                              ) : (
                                   <li className="no-option-assign no-email">No options</li>
                              )}
                         </ul>
                    </div>
               ) : (
                    <>
                         <div className={classNames('select-user-email', { 'is-invalid': !!error })} onClick={handleClickExpandOption}>
                              <div className="icon-dropdown">
                                   <CImage
                                        src={images.arrowDownDarkCeruleanIcon}
                                        className="icon-item"
                                        alt="Arrow Down Blue Icon"
                                        width={10}
                                        height={6}
                                   />
                              </div>
                              <CFormInput
                                   id="userId"
                                   readOnly
                                   className="member-add-seat"
                                   placeholder="Select an existing user"
                                   disabled={disabled}
                                   value={value}
                              />
                         </div>
                         <CFormFeedback invalid>{error}</CFormFeedback>
                    </>
               )}
          </div>
     );
};

AssignSeatUserSearch.defaultProps = {
     initialValues: [],
     value: '',
     disabled: false,
     setFieldValue: DEFAULT_FN,
};

export default memo(AssignSeatUserSearch);
